import { useEffect, useId, useState, useMemo } from 'react';
import clsx from 'clsx';
import { FaqClusterItem } from '../faq-cluster';
import { useDataLayer } from '@/hooks/use-data-layer';

export function FaqItem({ question, answer, index, textColor = 'r-text-black' }: FaqClusterItem & { index: number }) {
    const id = useId();
    const { dataLayerPush } = useDataLayer();
    const [isOpen, setIsOpen] = useState(false);
    const plusIcon = useMemo(() => (textColor === 'r-text-black' ? '/assets/icons/plus.svg' : '/assets/icons/plus-white.svg'), [textColor]);
    if (!question || !answer) {
        return null;
    }

    useEffect(() => {
        if (isOpen) {
            dataLayerPush(
                {
                    event: 'FaqTopic',
                    FaqTopic: question,
                },
                { usePageProductData: true }
            );
        }
    }, [isOpen]);

    const accordionId = `accordion-${id}-${index}`;
    const sectionId = `section-${id}-${index}`;

    return (
        <details className={clsx('r-border-b', textColor)}>
            <summary
                id={accordionId}
                onClick={() => setIsOpen(!isOpen)}
                className={clsx(
                    'r-flex r-w-full r-items-center r-justify-between r-gap-3 r-rounded-xl r-py-3 r-align-middle r-font-bold hover:r-cursor-pointer',
                    textColor
                )}
            >
                <span className={textColor}>{question}</span>
                <img
                    alt=""
                    width={14}
                    height={22}
                    src={plusIcon}
                    className={clsx('r-size-8 r-p-2 r-transition r-duration-200', {
                        'r-rotate-45': isOpen,
                    })}
                />
            </summary>
            <div
                className={clsx('r-grid r-transition-[grid-template-rows] r-duration-300', {
                    'r-grid-rows-[1fr]': isOpen,
                    'r-grid-rows-[0fr]': !isOpen,
                })}
            >
                <div id={sectionId} className="styled-link r-row-span-2 r-overflow-hidden">
                    <p className="r-pb-2" dangerouslySetInnerHTML={{ __html: answer }} />
                </div>
            </div>
        </details>
    );
}
